<template>
  <el-dialog :close-on-click-modal="false"  title="组织结构" :visible.sync="orgDialogVisible" width="520px" :before-close="handleClose" append-to-body>
    <el-input placeholder="输入关键字进行过滤" v-model="filterText">
    </el-input>
    <p style="margin-top:12px;">
      已选择：
      <template v-if="multiple">
        <span v-if="!checkedNodes.length" style="color:#999;">选择组织结构</span>
        <el-tag v-for="(node, idx) in checkedNodes" :key="idx" type="info" style="margin:2px;">{{node.structure_names || node.name}}</el-tag>
      </template>
      <el-tag v-else type="info">{{selectedNode?selectedNode.structure_names||selectedNode.name:'选择组织结构'}}</el-tag>
    </p>
    <el-scrollbar style="height:240px;padding:8px 0;">
      <el-tree class="filter-tree" :expand-on-click-node='false' :default-expanded-keys="defaultKey" :data="data" node-key="id" @node-click="handleNodeClick" :props="defaultProps" :filter-node-method="filterNode" ref="tree" :show-checkbox="multiple" :check-strictly="checkStrictly" @check="handleCheck">
      </el-tree>
    </el-scrollbar>
    <span slot="footer" class="dialog-footer">
      <el-button @click="orgDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleOrgan">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ['total', 'getSelect', 'handleOrganQuery', 'level', 'multiple', 'checkStrictly', 'checkLevel'],
  //level 1院系 2专业 3班级
  data() {
    return {
      orgDialogVisible: false,
      filterText: '',
      checkedNodes: [],
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      data: [],
      defaultKey: ['1'],
      selectedNode: null,
      nodeArr: [],
      allNode: [],
      filters: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    let organs = JSON.parse(JSON.stringify(this.$store.state.organs));
    if (organs && organs.length) {
      organs.map((item) => {
        item.id = '1';
        return item;
      });
      // console.log(organs);
      // this.data = this.translateDataToTree(organs);
      // this.data = organs;
      if (this.level) {
        this.data = this.filterTree(organs, this.level, 'level');
      } else {
        this.data = organs;
      }
      if (this.multiple && this.checkLevel) {
        this.setNodeDisabled(this.data);
      }
      this.getAllNode(organs);
    }
  },
  computed: {
    nodeArrName: function () {
      let str = '';
      // console.log(this.nodeArr);
      // if(this.nodeArr.length){
      //   str = this.nodeArr.map(item=>{return item.name}).reverse().join('/')+'/'
      // }else{
      //   str = ''
      // }
      if (this.selectedNode) {
        str = str + this.selectedNode.structure;
      }
      return str;
    },
  },
  methods: {
    filterTree(arr, val, params) {
      return arr
        .filter((item) => {
          return val.indexOf(item[params]) > -1 || !item[params];
        })
        .map((item) => {
          item = Object.assign({}, item);
          if (item.sub) {
            item.sub = this.filterTree(item.sub, val, params);
          }
          return item;

          // else {
          //   return null;
          // }
        });
    },
    getAllNode(nodes) {
      nodes.map((item) => {
        this.allNode.push({
          id: item.id,
          name: item.name,
          level: item.level,
          structure_ids: item.structure_ids,
        });
        if (item.sub) {
          this.getAllNode(item.sub);
        }
      });
    },
    handleNodeClick(data) {
      this.selectedNode = data;
      this.$emit('getSelect', data);
      // this.nodeArr=[]
      // this.organName(data)
    },
    handleOrgan() {
      if (this.multiple) {
        this.$emit('getSelectList', this.checkedNodes);
      }
      this.$emit('handleOrganQuery');
    },
    handleCheck(node, data) {
      this.checkedNodes = data.checkedNodes;
      this.$emit('getSelect', this.checkedNodes);
    },
    handleClose() {
      this.orgDialogVisible = false;
    },
    organName(node) {
      //获取选中的节点上下级
      // console.log(node);
      this.allNode.map((item) => {
        if (item.structure_ids.indexOf(node.id) > -1) {
          this.nodeArr.push(item);
        }
      });
    },
    translateDataToTree(data) {
      let parents = data.filter((value) => value.fdParentId == 'undefined' || value.fdParentId == null || value.fdParentId == 0);
      this.defaultKey = [parents[0].id];
      this.selectedNode = parents[0];
      let children = data.filter((value) => value.fdParentId != 'undefined' && value.fdParentId != null && value.fdParentId != 0);
      let translator = (parents, children) => {
        parents.forEach((parent) => {
          children.forEach((current, index) => {
            if (current.fdParentId === parent.id) {
              let temp = JSON.parse(JSON.stringify(children)); //深拷贝
              temp.splice(index, 1);
              translator([current], temp);
              typeof parent.children !== 'undefined' ? parent.children.push(current) : (parent.children = [current]);
            }
          });
        });
      };

      translator(parents, children);
      return parents;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    setNodeDisabled(nodes) {
      nodes.forEach((item) => {
        if (item.level !== this.checkLevel) {
          item.disabled = true;
        }
        if (item.sub && item.sub.length) {
          this.setNodeDisabled(item.sub);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.filter-tree {
  // padding: 8px 0;
  overflow: auto;
  // margin-top: 8px;
}
/deep/.el-tree-node:focus > .el-tree-node__content {
  background-color: #315a98;
  color: #fff;
}
/deep/ .el-scrollbar__wrap{
  overflow-x: hidden;
}
</style>
